module.exports = __webpack_public_path__ + "static/media/invoice_no_labor.7900cc9e.png";